import { render, staticRenderFns } from "./ProviderBankdraftsView.vue?vue&type=template&id=37ce1216&lang=pug"
import script from "./ProviderBankdraftsView.vue?vue&type=script&lang=ts"
export * from "./ProviderBankdraftsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ce1216')) {
      api.createRecord('37ce1216', component.options)
    } else {
      api.reload('37ce1216', component.options)
    }
    module.hot.accept("./ProviderBankdraftsView.vue?vue&type=template&id=37ce1216&lang=pug", function () {
      api.rerender('37ce1216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/ProviderBankdrafts/ProviderBankdraftsView.vue"
export default component.exports